var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "signOut_svg__a",
    width: 28,
    height: 29,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h28v28H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#signOut_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M5.833 25a2.25 2.25 0 0 1-1.648-.685 2.25 2.25 0 0 1-.685-1.648V6.333q0-.961.685-1.648A2.25 2.25 0 0 1 5.833 4h7q.495 0 .832.335.335.336.335.832t-.335.83-.832.336h-7v16.334h7q.495 0 .832.335.335.335.335.831t-.335.832-.832.335zm14.205-9.333h-8.371q-.495 0-.832-.336a1.13 1.13 0 0 1-.335-.831q0-.496.335-.831.336-.336.832-.336h8.37l-2.187-2.187a1.07 1.07 0 0 1-.32-.788q0-.466.32-.816t.817-.365q.495-.015.845.335l4.171 4.171q.35.35.35.817t-.35.817l-4.17 4.17q-.35.351-.832.336a1.2 1.2 0 0 1-.831-.365 1.14 1.14 0 0 1-.306-.83q.014-.483.335-.803z"
  }))));
};
export default SvgSignOut;